import { AvailableIcons } from '@asn/icon';

import { CUSTOM_ELEMENTS_SCHEMA, Component, ViewEncapsulation, input, output } from '@angular/core';

import '@asn/icon';

/**
 * This is the Card Component. It renders a shaded panel, which we call a card, title and icon are optional.
 **/
@Component({
    selector: 'ap-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ApCardComponent {
    /**
     * Shows title in the card header
     */
    public readonly title = input<string>('');

    /**
     * Shows icon in the card header, use icon name from the icon component
     */
    public readonly iconName = input<AvailableIcons>(undefined);

    /**
     * Aria label to place on icon
     */
    public readonly iconAriaLabel = input<string>(undefined);

    /**
     * Eventemitter emits when the icon is clicked
     */
    public readonly iconClick = output<void>();

    /**
     * Emit click event on icon click
     * @internal
     */
    public onIconClick(): void {
        this.iconClick.emit(undefined);
    }
}
